var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VipCustomer',{on:{"close":_vm.close,"openUrl":_vm.openUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }